import { CheckIcon, CardIcon, GlobeIcon, ShieldIcon } from 'components/icons/TrustIcons';

const ITEMS = [
  { Icon: CheckIcon, label: 'Genuine stock', sub: 'Verified suppliers, no fakes' },
  { Icon: CardIcon, label: 'Pay on order', sub: 'MTN MoMo, Airtel Money, cash' },
  { Icon: GlobeIcon, label: 'Kampala & countrywide', sub: 'Delivery arranged on WhatsApp' },
  { Icon: ShieldIcon, label: 'Warranty included', sub: 'On all phones & laptops' },
];

export function TrustBar() {
  return (
    <div className="flex flex-wrap justify-center border-y border-white/10 bg-bg2">
      {ITEMS.map(({ Icon, label, sub }, i) => (
        <div
          key={label}
          className={`flex items-center gap-3 px-6 py-5 text-sm sm:px-8 ${
            i < ITEMS.length - 1 ? 'border-r border-white/10' : ''
          }`}
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-dim text-accent">
            <Icon />
          </span>
          <div>
            <div className="text-sm font-bold">{label}</div>
            <div className="text-xs text-text-muted">{sub}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
